import {useState} from "react";
import PropTypes from "prop-types";

import Icon from "../Components/Icon/Icon";

import {ICON_NAMES} from "./generalConstants.js/generalConstants";
import ToolTip from "./ToolTip";

const QuestionItem = ({title, tooltipShown = false, className, onClick, style, bottomTooltip}) => {
  const [show, setShow] = useState(false);
  return (
    <ToolTip title={title} open={tooltipShown || show} className={className} style={style} bottom={bottomTooltip}>
      <Icon
        name={ICON_NAMES.HELP}
        width={18}
        height={18}
        onClick={onClick || (() => {})}
        onMouseEnter={() => setShow(true)}
        onMouseLeave={() => setShow(false)}
        style={onClick ? {cursor: "pointer"} : undefined}
      />
    </ToolTip>
  );
};
QuestionItem.propTypes = {
  title: PropTypes.oneOfType([PropTypes.array, PropTypes.string, PropTypes.object]),
  onClick: PropTypes.func,
};

export default QuestionItem;
